import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Rating, Typography } from "@mui/material";
import { BASE_URL } from "../config/config";

// Local state on purpose, not the shared propertyReview redux slice — a
// listing grid renders many of these at once, and a shared "last fetched"
// average/count would flicker between cards as each one's request resolves.
//
// Only admin-approved reviews ever reach here (see the server route), so
// this is safe to show on public listings without any further filtering.
export default function PropertyRatingBadge({ flatId, size = "small" }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    if (!flatId) return;
    let cancelled = false;

    axios
      .get(`${BASE_URL}/property-reviews/${flatId}`)
      .then(({ data }) => {
        if (!cancelled) setSummary(data?.data || null);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [flatId]);

  if (!summary?.count) return null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
      <Rating value={summary.average} precision={0.1} readOnly size={size} />
      <Typography variant="caption" color="text.secondary">
        {summary.average.toFixed(1)} ({summary.count})
      </Typography>
    </Box>
  );
}
